import React from "react";

const Image = (props) => (
  <div
    onClick={props.zoom}
    style={{
      float: "left",
      margin: "15px 0 0 15px",
      cursor: "pointer",
      width: "150px",
      height: "206px",
    }}
  >
    <img
      src={
        props.content.front.url ? props.content.front.url : props.content.front
      }
      style={{ width: "150px" }}
    />
  </div>
);
export default class Gallery extends React.Component {
  state = {
    wp: [],
    acf: [],
    categories: [],
    zoomed: false,
    genre: "Wszystkie",
    loaded: 0,
  };
  componentDidMount() {
    this.loadContents();
  }
  loadContents = () => {
    fetch(
      "https://arteco-wp.prod.krzysztofsikorski.pl/wp-json/acf/v3/posts?per_page=100"
    )
      .then((response) => {
        return response.json();
      })
      .then((myJson) => {
        this.setState({
          acf: myJson.length ? this.state.acf.concat(myJson) : this.state.acf,
          loaded: this.state.loaded + 1,
        });
      });

    fetch(
      "https://arteco-wp.prod.krzysztofsikorski.pl/wp-json/acf/v3/posts?per_page=100&page=2"
    )
      .then((response) => {
        return response.json();
      })
      .then((myJson) => {
        this.setState({
          acf: myJson.length ? this.state.acf.concat(myJson) : this.state.acf,
          loaded: this.state.loaded + 1,
        });
      });

    fetch(
      "https://arteco-wp.prod.krzysztofsikorski.pl/wp-json/acf/v3/posts?per_page=100&page=3"
    )
      .then((response) => {
        return response.json();
      })
      .then((myJson) => {
        this.setState({
          acf: myJson.length ? this.state.acf.concat(myJson) : this.state.acf,
          loaded: this.state.loaded + 1,
        });
      })
      .catch(() => {
        this.setState({
          loaded: this.state.loaded + 1,
        });
      });

    fetch(
      "https://arteco-wp.prod.krzysztofsikorski.pl/wp-json/wp/v2/posts?per_page=100&_fields=title,id,categories"
    )
      .then((response) => {
        return response.json();
      })
      .then((myJson) => {
        this.setState({
          wp: myJson.length ? this.state.wp.concat(myJson) : this.state.wp,
          loaded: this.state.loaded + 1,
        });
      });

    fetch(
      "https://arteco-wp.prod.krzysztofsikorski.pl/wp-json/wp/v2/posts?per_page=100&_fields=title,id,categories&page=2"
    )
      .then((response) => {
        return response.json();
      })
      .then((myJson) => {
        this.setState({
          wp: myJson.length ? this.state.wp.concat(myJson) : this.state.wp,
          loaded: this.state.loaded + 1,
        });
      });

    fetch(
      "https://arteco-wp.prod.krzysztofsikorski.pl/wp-json/wp/v2/posts?per_page=100&_fields=title,id,categories&page=3"
    )
      .then((response) => {
        return response.json();
      })
      .then((myJson) => {
        this.setState({
          wp: myJson.length ? this.state.wp.concat(myJson) : this.state.wp,
          loaded: this.state.loaded + 1,
        });
      })
      .catch(() => {
        this.setState({
          loaded: this.state.loaded + 1,
        });
      });

    fetch(
      "https://arteco-wp.prod.krzysztofsikorski.pl/wp-json/wp/v2/categories?_fields=id,name"
    )
      .then((response) => {
        return response.json();
      })
      .then((myJson) => {
        this.setState({
          categories: myJson,
          loaded: this.state.loaded + 1,
        });
      });

    // getContents().then(results => {
    //   this.setState({
    //     contents: results.data.data.contents
    //   })
    // })
  };
  render() {
    const { genre, wp, acf, categories, loaded } = this.state;

    if (loaded < 7) return null;

    const contents = wp
      .map((post) => {
        if (!post.title) {
          console.log(post);
        }

        const acfEntry = acf.find((el) => el.id === post.id)

        if (!acfEntry) return false;
        return {
          title: post.title.rendered,
          front: acfEntry.acf.front,
          back: acfEntry.acf.back,
          category: categories.find((el) => el.id === post.categories[0]).name,
        };
      })
      .filter(e => e)
      .filter((el) => genre === "Wszystkie" || el.category === genre);

    // const contents = this.state.contents
    //   .map(contentParser)
    return (
      <React.Fragment>
        {this.state.zoomed !== false && (
          <div
            onClick={() => this.setState({ zoomed: false })}
            style={{
              zIndex: 1000,
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.8)",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                visibility: this.state.zoomed > 0 ? "visible" : "hidden",
                cursor: "pointer",
              }}
              onClick={(e) => {
                e.stopPropagation();
                this.setState({
                  zoomed: this.state.zoomed - 1,
                });
              }}
            >
              <i
                className="fal fa-angle-left fa-3x"
                style={{ margin: "0 15px" }}
              ></i>
            </div>
            <div>
              <div
                className="flip-container"
                onTouchStart="this.classList.toggle('hover');"
                style={{ border: "" }}
              >
                <div className="flipper">
                  <div className="front">
                    <img
                      src={
                        contents[this.state.zoomed].front.url
                          ? contents[this.state.zoomed].front.url
                          : contents[this.state.zoomed].front
                      }
                    />
                  </div>
                  <div className="back" style={{ position: "relative" }}>
                    <img
                      src={
                        contents[this.state.zoomed].back.url
                          ? contents[this.state.zoomed].back.url
                          : contents[this.state.zoomed].back
                      }
                    />
                    <div
                      style={{
                        fontSize: 24,
                        position: "absolute",
                        bottom: 10,
                        width: "100%",
                        textAlign: "center",
                        left: 0,
                        textShadow: "0px 0px 3px black",
                        fontVariant: "small-caps",
                      }}
                    >
                      oryginał
                    </div>
                  </div>
                </div>
              </div>
              <h3 style={{ fontSize: 13, marginTop: "10px" }}>
                {contents[this.state.zoomed].title}
              </h3>
            </div>
            <div
              style={{
                visibility:
                  this.state.zoomed < contents.length - 1
                    ? "visible"
                    : "hidden",
                cursor: "pointer",
              }}
              onClick={(e) => {
                e.stopPropagation();
                this.setState({
                  zoomed: this.state.zoomed + 1,
                });
              }}
            >
              <i
                className="fal fa-angle-right fa-3x"
                style={{ margin: "0 15px" }}
              ></i>
            </div>
          </div>
        )}
        <div className="container">
          <div className="columns" style={{ paddingTop: 70 }}>
            <div className="column">
              {contents.map((content, ind) =>
                content.front || content.back ? (
                  <Image
                    content={content}
                    zoom={() =>
                      this.setState({
                        zoomed: ind,
                      })
                    }
                  />
                ) : null
              )}
            </div>
            <div className="column is-3">
              <aside className="menu">
                <p className="menu-label">Tematyka</p>
                <ul className="menu-list">
                  <li>
                    <a
                      className={
                        this.state.genre === "Wszystkie" ? "is-active" : ""
                      }
                      style={
                        this.state.genre === "Wszystkie"
                          ? {
                              background: "rgba(255, 255, 255, 0.7)",
                              color: "black",
                            }
                          : {}
                      }
                      onClick={() => this.setState({ genre: "Wszystkie" })}
                    >
                      Wszystkie
                    </a>
                  </li>
                  {categories.map(({ name }) => (
                    <li>
                      <a
                        className={this.state.genre === name ? "is-active" : ""}
                        style={
                          this.state.genre === name
                            ? {
                                background: "rgba(255, 255, 255, 0.7)",
                                color: "black",
                              }
                            : {}
                        }
                        onClick={() => this.setState({ genre: name })}
                      >
                        {name}
                      </a>
                    </li>
                  ))}
                </ul>
              </aside>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Gallery.js